//-==================================================================
//-                            index.js  (PC)
//-=================================================================
// 【読込】「gulp-file-include」で外部ファイルをインクルードできるようにした
// 【注意！】アットマークを書くだけでおこられる。たとえ全角でも
// 【注意！】 コメントアウトできない。「//」をつけてもファイルが読込まれてしまう
// 【注意！】圧縮された「minファイル」では、うまくいかない！
//-=================================================================


// jQueryイージング
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
{
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158; 
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */

// ローダー
(function() {
  (function($) {
    var timer;
    timer = false;
    $(window).resize(function() {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout((function() {
        $('body').addClass('loaded');
      }), 200);
    });
    jQuery.event.add(window, 'load', function() {
      $('body').addClass('loaded');
      $('#HeaderFix').addClass('byeHeader');
    });
    $('body').addClass('loaded');
    $('#HeaderFix').addClass('byeHeader');
  })(jQuery);

}).call(this);


// メイン
(function() {
  (function($) {
    var $HeaderFix, menuHeight, pagetop, showtPos, startPos;
    $('#toggleBtn').click(function() {
      $('#headerNavi').toggleClass('open');
    });
    $('a[href^="#"]').click(function() {
      var href, position, speed, target;
      speed = 500;
      href = $(this).attr('href');
      target = $(href === '#' || href === '' ? 'html' : href);
      position = target.offset().top;
      $('body,html').animate({
        scrollTop: position
      }, speed, 'swing');
    });
    pagetop = $('#PageTop');
    pagetop.fadeOut();
    $HeaderFix = $('#HeaderFix');
    menuHeight = $('header').height();
    startPos = 0;
    showtPos = 200;
    $(window).scroll(function() {
      var currentPos;
      if ($(this).scrollTop() > 100) {
        pagetop.fadeIn();
      } else {
        pagetop.fadeOut();
      }
      currentPos = $(this).scrollTop();
      console.log("currentPos:" + currentPos);
      if (currentPos > startPos) {
        if ($(window).scrollTop() >= showtPos) {
          $HeaderFix.addClass("showGlobalNaviALL");
          $HeaderFix.removeClass("byeHeader");
        } else {
          $HeaderFix.removeClass("showGlobalNaviALL");
          $HeaderFix.addClass("byeHeader");
        }
      } else {
        if ($(window).scrollTop() >= showtPos) {
          $HeaderFix.addClass("showGlobalNaviALL");
          $HeaderFix.removeClass("byeHeader");
        } else {
          $HeaderFix.removeClass("showGlobalNaviALL");
          $HeaderFix.addClass("byeHeader");
        }
      }
      startPos = currentPos;
    });
  })(jQuery);

}).call(this);


// モーダル
(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  (function($) {
    var simpleModalWindow;
    simpleModalWindow = function() {
      var bg, body, closeM, closeM2, scrollpos, sp, win;
      scrollpos = 0;
      sp = 500;
      win = $('window');
      body = $('body');
      bg = $('<div id="modal-bg"></div>');
      bg.css('opacity', '0');
      $(".modal").on('click', function() {
        var check, contents, img, link, mInner, mWin, py, scrollTag, self, view, wh;
        self = $(this);
        link = self.attr('href');
        check = link.slice(0, 1);
        py = win.scrollTop();
        wh = win.height();
        if (window.chrome || indexOf.call(document.documentElement.style, 'WebkitAppearance') >= 0) {
          scrollTag = 'body';
        } else {
          scrollTag = 'html';
        }
        scrollpos = $(scrollTag).scrollTop();
        $('#all-wrapper').addClass('fixed').css({
          'top': -scrollpos
        });
        mWin = $('<div id="modal-win"><div id="modal-win-inner"></div></div>');
        body.append(mWin);
        mInner = mWin.find('#modal-win-inner');
        mInner.css('opacity', '0');
        mWin.prepend(bg);
        view = function(a_elm) {
          var h, mt, w;
          w = a_elm.outerWidth();
          h = a_elm.outerHeight();
          wh = $(window).height();
          mt = (wh - h) / 2;
          bg.animate({
            'opacity': '.85'
          }, sp);
          console.log("h:" + h);
          console.log("wh:" + wh);
          console.log("scrollpos:" + scrollpos);
          if (h > wh) {
            mInner.css('top', 10 + 'px');
            $('html,body').animate({
              scrollTop: 0
            }, '300');
          } else {
            mInner.css('top', mt + 'px');
          }
          mInner.css({
            'width': w,
            'height': h
          }).animate({
            'opacity': '1'
          }, sp);
        };
        if (check !== "#") {
          mInner.append('<img src="' + link + '" alt="" />');
          img = mWin.find('img');
          img.on('load', function() {
            return view(img);
          });
        } else {
          contents = $(link);
          mInner.append(contents);
          contents.css({
            'display': 'block',
            'zIndex': '101'
          });
          view(contents);
        }
        return false;
      });
      $('.modal-move').click(function(e) {
        var change, check, link, mInner, mWin, py, self, wh;
        py = win.scrollTop();
        wh = win.height();
        self = e.target;
        console.log(e.target);
        link = $(self).attr('href');
        check = link.slice(0, 1);
        console.log("check:" + check);
        mWin = $('#modal-win');
        mInner = mWin.find('#modal-win-inner');
        change = function() {
          var contents, move_h, move_mt, move_w, nowContents;
          nowContents = mInner.children();
          if (nowContents.attr('id')) {
            body.append(nowContents);
            nowContents.hide();
          }
          mWin.remove();
          mWin = $('<div id="modal-win"><div id="modal-win-inner"></div></div>');
          body.append(mWin);
          mInner = mWin.find('#modal-win-inner');
          mInner.css('opacity', '0');
          mWin.prepend(bg);
          contents = $(link);
          mInner.append(contents);
          contents.css({
            'display': 'block',
            'zIndex': '101'
          });
          move_w = contents.outerWidth();
          move_h = contents.outerHeight();
          move_mt = (wh - move_h) / 2 + py;
          if (move_h > wh) {
            return mWin.css('top', '10px');
          } else {
            mWin.css('top', move_mt + 'px');
            return mInner.css({
              'width': move_w,
              'height': move_h
            }).animate({
              'opacity': '1'
            }, sp);
          }
        };
        if (check === "#") {
          mInner.animate({
            'opacity': '0'
          }, sp, change);
        }
        return false;
      });
      closeM = function() {
        var contents, i, j, mInner, mWin, ref, scrollTag;
        mWin = $('#modal-win');
        mInner = mWin.find('#modal-win-inner');
        contents = mInner.children();
        mInner.animate({
          opacity: '0'
        }, sp, function() {
          if (contents.attr('id')) {
            body.append(contents);
            contents.hide();
          }
          mWin.remove();
        });
        bg.animate({
          'opacity': '0'
        }, sp);
        $('#all-wrapper').removeClass('fixed');
        if (window.chrome || indexOf.call(document.documentElement.style, 'WebkitAppearance') >= 0) {
          scrollTag = 'body';
        } else {
          scrollTag = 'html';
        }
        $(scrollTag).scrollTop(scrollpos);
        console.log(scrollTag);
        console.log(scrollpos);
        for (i = j = 0, ref = document.getElementsByTagName("audio").length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
          document.getElementsByTagName("audio")[i].pause();
        }
      };
      closeM2 = function() {
        event.preventDefault();
        return $('#modal-bg').click();
      };
      $('.modal-close').on('click', closeM2);
      $(document).on('click', '#modal-bg', closeM);
    };
    simpleModalWindow();
  })(jQuery);

}).call(this);

